import { useMemo } from "react";
import { ViewBooking } from "collins-js-sdk";
import {
  getBookingPaymentTotal,
  getBookingAuthTotal,
  getActivePreorderCount
} from "../../../../../utils/runsheetUtils";

export interface BookingStats {
  total: number;
  checkedIn: number;
  pending: number;
  totalRevenue: number;
  avgPartySize: number;
  preOrderCount: number;
}

export const useBookingStats = (
  sortedBookings: ViewBooking[]
): BookingStats => {
  return useMemo(() => {
    // Filter out rejected bookings from stats calculation
    const nonRejectedBookings = sortedBookings.filter(
      (b) => b.status !== "rejected"
    );

    const total = nonRejectedBookings.length;
    const checkedIn = nonRejectedBookings.filter(
      (b) =>
        b.currentStage === "checked-in" ||
        b.currentStage === "seated" ||
        b.currentStage === "arrived"
    ).length;
    const pending = total - checkedIn;

    const totalRevenue = nonRejectedBookings.reduce((sum, booking) => {
      const paymentTotal = getBookingPaymentTotal(booking);
      const authTotal = getBookingAuthTotal(booking);
      return sum + paymentTotal + authTotal;
    }, 0);

    const totalGuests = nonRejectedBookings.reduce(
      (sum, b) => sum + (b.actualGuests ?? 0),
      0
    );
    const avgPartySize = total > 0 ? Math.round(totalGuests / total) : 0;

    const preOrderCount = nonRejectedBookings.reduce(
      (sum, b) => sum + getActivePreorderCount(b),
      0
    );

    return {
      total,
      checkedIn,
      pending,
      totalRevenue,
      avgPartySize,
      preOrderCount
    };
  }, [sortedBookings]);
};
